import { Buffer } from 'buffer'
import * as SecureStore from 'expo-secure-store'

import { AuthState } from './auth'

const notificationsKey = (id: string) => {
  const encodedId = Buffer.from(id, 'utf8')
    .toString('base64')
    .replaceAll('+', '-')
    .replaceAll('/', '_')
    .replace(/=+$/, '')
  return `ybb_notifications_${encodedId}`
}

// import { handler as ErrorLog } from '../../errorHandler'

// initialize with a stub
const store = {
  async loadAuthAsync(): Promise<AuthState | null> {
    try {
      const auth = await SecureStore.getItemAsync('ybb_auth')
      return await JSON.parse(auth as string)
    } catch (e) {
      // ErrorLog(Error(`get auth from store failed: ${e}`), false)
      console.log(`get auth from store failed: ${e}`)
      throw e
    }
  },
  async saveAuthAsync(value: AuthState): Promise<void> {
    try {
      await SecureStore.setItemAsync('ybb_auth', JSON.stringify(value))
    } catch (e) {
      // ErrorLog(Error(`save auth in store failed: ${e}`), false)
      console.log(`save auth in store failed: ${e}`)
    }
  },
  async updateAuthAsync(value: AuthState): Promise<void> {
    try {
      await SecureStore.setItemAsync('ybb_auth', JSON.stringify(value))
    } catch (e) {
      // ErrorLog(Error(`merge auth in store failed: ${e}`), false)
      console.log(`merge auth in store failed: ${e}`)
    }
  },
  async clearAuthAsync(): Promise<void> {
    try {
      await SecureStore.deleteItemAsync('ybb_auth')
    } catch (e) {
      console.log(`remove auth in store failed: ${e}`)
    }
  },
  async setItemAsync(key: string, value: string) {
    try {
      await SecureStore.setItemAsync(key, value)
      return true
    } catch (e) {
      console.log(e)
      return false
    }
  },
  async getItemAsync(key: string) {
    try {
      const value = await SecureStore.getItemAsync(key)
      return value
    } catch (e) {
      console.log(e)
    }
  },
  async setNotificationsStatus(id: string, value: object) {
    try {
      await SecureStore.setItemAsync(notificationsKey(id), JSON.stringify(value))
      return true
    } catch (e) {
      console.log(e)
      return false
    }
  },
  async getNotificationsStatus(id: string) {
    try {
      const value = await SecureStore.getItemAsync(notificationsKey(id))
      return value ? JSON.parse(value) : null
    } catch (e) {
      console.log(e)
    }
  }
}

export default store
